import { useEffect, useState } from 'react';
import './ArtistCard.css';
import { API_BASE_URL } from '../../utils';

const ArtistCard = ({ specialArtist }) => {
    const url = `${API_BASE_URL}/master/assets/uploads/`;

    const formattedArtists = specialArtist.map((artist) => ({
        name: artist.name,
        genres: artist.genre.split(','),
        image: artist.cover_pic ? url + artist.cover_pic : '',
        profilePic: url + artist.profile_pic,
        video: artist.video ? url + artist.video : null,
    }));

    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(false);

    const triggerFade = (index) => {
        setFade(true);
        setTimeout(() => {
            setCurrentIndex(index);
            setFade(false);
        }, 300); // Match with CSS transition time
    };

    useEffect(() => {
        const interval = setInterval(() => {
            // triggerFade((currentIndex + 1) % formattedArtists.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [currentIndex]);

    const handleThumbnailClick = (index) => {
        triggerFade(index);
    };

    const currentArtist = formattedArtists[currentIndex];

    if (!specialArtist || specialArtist.length === 0) {
        return <div>No artists available</div>;
    }

    return (
        <div className="artist-card-container">
            <div className="artist-card-background-wrapper">
                {currentArtist?.video ? (
                    <video
                        className={`artist-card-background ${fade ? 'fade' : ''}`}
                        src={currentArtist?.video}
                        autoPlay
                        muted
                        loop
                        playsInline
                    />
                ) : (
                    <div
                        className={`artist-card-background ${fade ? 'fade' : ''}`}
                        style={{ backgroundImage: `url(${currentArtist?.image})` }}
                    ></div>
                )}
            </div>

            <div className="artist-card-overlay">
                <div className="artist-card-content">
                    <div className="artist-info-wrapper">
                        <h2 className="artist-name">{currentArtist?.name}</h2>
                        <div className="artist-genres">
                            {currentArtist?.genres?.map((genre, index) => (
                                <span className="genre-tag" key={index}>
                                    {genre}
                                </span>
                            ))}
                        </div>
                        <button className="view-profile-btn">View Profile</button>
                        <div className="thumbnail-gallery">
                            {formattedArtists.map((artist, index) => (
                                <div className='thumbnail-wrapper' key={index}>
                                <img
                                    src={artist?.profilePic}
                                    alt={`thumb-${index}`}
                                    className={`thumbnail-img ${index === currentIndex ? 'active' : ''}`}
                                    onClick={() => handleThumbnailClick(index)}
                                />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArtistCard;
